module.exports = __webpack_public_path__ + "static/logo-white-d14c92239eb3e14b4a6e425eff5142f1.png";